<!-- Footer de la aplicación, contiene los logos de las entidades que apoyan el proyecto. Se adapta a diferentes tamaños de pantalla utilizando clases de Tailwind CSS. -->
<footer class="py-16" style="background-color: #1C3762;">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8 3xl:px-5">
        <!-- Modificamos el grid para adaptarse mejor a dispositivos pequeños y medios -->
        <div class="grid grid-cols-1 md:grid-cols-3 gap-10 sm:gap-14 items-center justify-items-center">
            <div class="flex items-center justify-center">
                <!-- Ajustamos las clases para mantener el aspecto original de la imagen y hacerla más pequeña en pantallas pequeñas -->
                <img [src]="footerImgs?.govco" alt="GOV.CO Logo" class="max-w-[200px] sm:max-w-sm md:max-w-[200px] xl:max-w-[250px] 3xl:max-w-xl h-auto 3xl:w-[300px] p-3">
            </div>
            <div class="flex items-center justify-center">
                <!-- Similar ajuste para la tercera imagen -->
                <img [src]="footerImgs?.idea" alt="IDEA Logo" class="max-w-[180px] sm:max-w-sm md:max-w-[170px] xl:max-w-[250px] 3xl:max-w-xl h-auto 3xl:w-[300px] p-3">
            </div>
            <div class="flex items-center justify-center">
                <!-- Similar ajuste para la segunda imagen -->
                <img [src]="footerImgs?.valormas" alt="Valor Logo" class="max-w-[200px] sm:max-w-sm md:max-w-[200px] xl:max-w-[250px] 3xl:max-w-xl h-auo 3xl:w-[300px] p-3">
            </div>
        </div>
    </div>
</footer>



